import { TypedDocumentNode } from 'apollo-angular';
import gql from 'graphql-tag';
import { IConfirmSending, ISendMassMessage } from '../interfaces/messages.interfaces';

export const sendOperationalMessage: TypedDocumentNode<
	IConfirmSending,
	ISendMassMessage
> = gql`
	mutation sendMassMessage(
		$subject: String!
		$text: String!
		$recipients: [String!]!
		$locations: [LocationInput]
		$attachmentPks: [UUID]
	) {
		sendMassMessage(
			subject: $subject
			text: $text
			recipients: $recipients
			locations: $locations
			attachmentPks: $attachmentPks
		) {
			success
		}
	}
`;
